import type { ReactNode } from "react";

/** A titled card: the only layout primitive this app needs. */
export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="tg-section__title">{title}</h2>
      <div className="tg-card">{children}</div>
    </section>
  );
}
